import { gql } from '@apollo/client/core';

export const WEBHOOK_SUBSCRIPTION_FIELDS = gql`
  fragment WebhookSubscriptionFields on WebhookSubscription {
    id
    destinationUrl
    topics
    includeHolds
    status
    delivering
    autoPauseReason
    autoPausedAt
    canEdit
    canTakeOwnership
    owner {
      kind
      name
      present
    }
    previousSecretExpiresAt
  }
`;
